import Icon from '@atoms/Icon/Icon';
import Text from '@atoms/Text/Text';
import { IconName } from '@models/IIcon';

export interface IListingPlaceholder {
  readonly dataTestId?: string;
  readonly iconName?: IconName;
  readonly title: string;
  readonly message: string;
}

const ListingPlaceholder = ({
  dataTestId,
  iconName = 'no-result',
  title,
  message,
}: IListingPlaceholder) => (
  <div
    className="tw-flex tw-w-full tw-flex-col tw-items-center tw-justify-center tw-pt-lg tw-text-center lg:tw-pt-12"
    data-testid={dataTestId}
  >
    <Icon name={iconName} size="6rem" className="tw-pb-xs" />
    <Text as="h2" variant="sub-headline" className="tw-pb-2 tw-font-light">
      {title}
    </Text>
    <Text variant="body" className="tw-text-grey-80">
      {message}
    </Text>
  </div>
);

export default ListingPlaceholder;
